import { ReportType } from "../reportype";

export class ReportFileDownloadForProviderRequest {
  public userName : string;
  public calProviderId: string;
  public memberId : string;
  public fileName: string;
  public reportType: ReportType;
}
